function WordPressPublishCtrl(
    $scope,
    $mdDialog,
    WriterAssistantService,
    article
) {
    const vm = $scope;

    vm.wordpress = {
        siteUrl: '',
        username: '',
        applicationPassword: '',
        status: 'draft',
    };
    vm.loading = false;
    vm.checkingConnection = false;
    vm.errorMessage = '';
    vm.result = null;
    vm.connectedUser = null;
    vm.publish = publish;
    vm.verifyConnection = verifyConnection;
    vm.credentialsChanged = credentialsChanged;
    vm.profileUrl = profileUrl;
    vm.cancel = cancel;

    function cancel() {
        if (vm.loading) {
            return;
        }
        $mdDialog.cancel();
    }

    function getErrorMessage(error) {
        if (error && error.message === 'invalid WordPress response') {
            return 'Il backend non ha restituito una risposta WordPress valida. Verifica che sia aggiornato e riavviato.';
        }
        if (error && error.data && error.data.error && error.data.error.message) {
            return error.data.error.message;
        }
        if (error && error.data && error.data.message) {
            return error.data.message;
        }
        if (error && error.error && error.error.message) {
            return error.error.message;
        }
        if (error && error.status === -1) {
            return 'Impossibile raggiungere il backend. Verifica che il server locale sia avviato.';
        }
        return 'Impossibile pubblicare su WordPress. Controlla i dati e riprova.';
    }

    function credentialsChanged() {
        vm.connectedUser = null;
        vm.result = null;
        vm.errorMessage = '';
    }

    function profileUrl() {
        if (!vm.wordpress.siteUrl) {
            return null;
        }

        try {
            const url = new URL(vm.wordpress.siteUrl.trim());
            if (url.protocol !== 'https:') {
                return null;
            }
            url.pathname = `${url.pathname.replace(/\/+$/, '')}/wp-admin/profile.php`;
            url.search = '';
            url.hash = 'application-passwords-section';
            return url.toString();
        } catch (error) {
            return null;
        }
    }

    function verifyConnection(form) {
        if (vm.checkingConnection || !form || form.$invalid) {
            return;
        }

        vm.checkingConnection = true;
        vm.errorMessage = '';
        vm.connectedUser = null;

        WriterAssistantService.verifyWordPressConnection(vm.wordpress)
            .then(function (connection) {
                if (!connection || !connection.connected || !connection.user) {
                    throw new Error('invalid WordPress response');
                }
                vm.connectedUser = connection.user;
                if (connection.user.capabilities
                    && connection.user.capabilities.publishPosts === false) {
                    vm.wordpress.status = 'draft';
                }
            })
            .catch(function (error) {
                vm.errorMessage = getErrorMessage(error);
            })
            .finally(function () {
                vm.checkingConnection = false;
            });
    }

    function publish(form) {
        if (vm.loading || !vm.connectedUser || !form || form.$invalid) {
            return;
        }

        vm.loading = true;
        vm.errorMessage = '';
        vm.result = null;

        WriterAssistantService.updateArticle(article.id, article)
            .then(function () {
                return WriterAssistantService.publishArticleToWordPress(article.id, vm.wordpress);
            })
            .then(function (result) {
                if (!result || !result.id) {
                    throw new Error('invalid WordPress response');
                }
                vm.loading = false;
                vm.result = result;
                vm.wordpress.applicationPassword = '';
            })
            .catch(function (error) {
                vm.loading = false;
                vm.errorMessage = getErrorMessage(error);
            });
    }
}

WordPressPublishCtrl.$inject = [
    '$scope',
    '$mdDialog',
    'WriterAssistantService',
    'article',
];

export default WordPressPublishCtrl;
